export const errors = {
    "notFound": {
        "404": "404 No Encontrado",
        "pageNotFound": "No se encuentra la página solicitada",
    },
    "tenant": {
        "payments": {
            "OnGoingPaymentTimeError": "el pago debe comenzar a partir de este mes en curso solo para los pagos del edificio",
            "PaymentsInThePastError": "el pago no está configurado correctamente, regresa a la primera pantalla e inténtalo de nuevo",
            "PartPayIsNotAllowedForTenant": "no se permite el pago parcial para el inquilino",
            "PartPayIsNotAllowedForManager": "no se permite el pago parcial para el administrador",
            "ExistingPaymentPlanRunning": "Existe un cargo fijo mensual",
            "AlreadyPayedError": "Se realizó el pago de los pagos seleccionados",
            "DebtTooManyMonthsError": "El número de pagos de los últimos meses es demasiado grande",
            "FailedTokenHasNotFailed": "El pago se ha actualizado correctamente. No se requiere ninguna acción adicional",
            "NumberOfInstallmentIsIllegal": "Ingresó un número de pagos no válido, inténtelo de nuevo",
            "NoNewPlansWereCreated": "No se realizaron pagos. Por favor, asegúrese de seleccionar la cantidad de pagos que desea."
        },
        "search": {
            "BuildingNotFound": "El edificio {{buildingName}} no se encontró en los registros de bllink",
            "SearchAddressIsNotCompleted": "No se buscó la dirección de un edificio específico. Se requiere el número de la calle, el nombre de la calle y la ciudad",
            "ApartmentNotFound": "No se encontró el número de apartamento {{apartmentNumber}}"
        }
    },
    "buildings": {
        "BuildingIsDisabled": "el edificio no existe o está inhabilitado temporalmente",
        "ManagerNotAllowedToViewBuilding": "administrador no permitido",
        "BuildingIsNotActive": "Edificio inactivo. Póngase en contacto con soporte en support@bllink.co o llamando al 03-5090045",
        "NotFullAddress": "Dirección incompleta. Verifique la dirección exacta, incluido el número de edificio"
    },
    "managers": {
        "NewOneTimeMissingTitle": "En el pago único nuevo, falta el título",
        "NewOneTimeMissingNumberOfInstallments": "En el pago único nuevo, falta la cantidad de cuotas",
        "NewOneTimeDidntAddAnyNewApartmentPayments": "El pago único nuevo no agregó ningún pago nuevo del apartamento",
        "ExternalSumDoesNotEqualTotalSum": " El monto registrado no coincide con los registros del sistema. El monto que se envió es {{externalAmountSent}}, pero el monto que figura en el sistema es {{totalSumSelectedToPay}}",
        "clearedCachedForBuildingSuccess": "Se borraron los datos almacenados en caché para {{buildingID}}. Si el edificio está asociado con una empresa de gestión, los datos también se actualizan.",
        "NoReceiptsForThisPartner": "No hay recibos debido al socio directo.",
        "NotTimeToChargeYet": "No se puede cargar el pago futuro con la tarjeta existente. Selecciona una nueva tarjeta.",
        "UserNotFound": "Usuario {{userID}} no encontrado",
        "NoAmountOrApartmentNumberFilled": "Error al leer datos. Verifique que todas las filas de apartamentos están llenas con el número de apartamento y la cantidad",
        "TerminalIsNotSupportedForRefund": "Esta transacción se realizó en una terminal que aún no admite créditos",
        "SchemaValidation": "Problema al enviar el archivo, error del servidor {{mensaje}}"
    },
    "general": {
        "generalError": "Error. Inténtalo de nuevo.",
        "networkError": "Error de red. Comprueba la conexión a Internet e inténtalo de nuevo.",
        "uploadError": "imagen de más de 2 MB",
        "timeout": "La solicitud tomó demasiado tiempo. Vuelva a intentarlo o póngase en contacto con el administrador."
    },
    "clientError": {
        "UNEXPECTED_ERROR": "Error inesperado",
        "REQUEST_VALIDATION_ERROR": "Solicitud de error de validación",
        "ACCESS_FORBIDDEN": "Acceso Prohibido",
        "APARTMENT_NO_OWNER": "No hay propietario definido para el apartamento",
        "APARTMENT_NO_RENTER": "No hay inquilino definido para el apartamento",
        "CAMPAIGN_ALREADY_RUNNING": "No se puede iniciar la campaña automática. Se deben finalizar las campañas en curso.",
        "TerminalIsNotSupportedForRefund": "Este terminal {{terminalName}} aún no es compatible con ptop",
        "NoAmountOrApartmentNumberFilled": "Falta el monto o el número de apartamento en la fila {{index}}",
        "UNKNOWN_ENTITY_TYPE": "Tipo de entidad desconocido {{entityType}}",
        "ENTITY_NOT_FOUND": "La entidad {{entityType}}:{{entityId}} no se encontró",
        "COMMENT_NOT_FOUND": "No se encontró el comentario con el ID {{commentId}}",
        "COMMENT_UPDATE_DISALLOWED": "Solo el creador del comentario puede actualizarlo",
        "NO_PDF_MAP_FOUND": "Ningún mapa en PDF coincide con el archivo proporcionado",
        "CAMPAIGN_NOT_FOUND": "No se encuentra el ID de la campaña {{campaignId}}",
        "CAMPAIGN_NOT_STARTED_YET": "El ID de la campaña {{campaignId}} aún no se inició",
        "CAMPAIGN_FINISHED": "El ID de la campaña {{campaignId}} ya terminó",
        "CAMPAIGN_NOT_ACTIVE": "El ID de la campaña {{campaignId}} no está activo",
        "CAMPAIGN_PRIZE_ALREADY_REQUESTED": "Este premio ya se solicitó, inténtalo más tarde.",
        "CAMPAIGN_PRIZE_NOT_FOUND": "No se encontró el ID del premio de la campaña {{campaignPrizeId}} o no participa en la campaña",
        "CAMPAIGN_LIMIT_REACHED": "Se alcanzó el límite del ID de campaña {{campaignId}}",
        "COINS_NOT_ENOUGH": "No hay suficientes monedas",
        "DATA_ROW_VALIDATION_ERROR": "Datos incorrectos en la fila {{row}}. Importación de datos interrumpida",
        "VALIDATE_BODY_ERROR": "El cuerpo de la solicitud no es válido",
        "VALIDATE_QUERY_ERROR": "La consulta de la solicitud no es válida",
        "GENERAL_BAD_PARAMS": "Se enviaron parámetros no válidos {{mensaje}}",
        "NO_PAYMENTS_SENT": "No se enviaron pagos en la solicitud enviada",
        "MissingDescriptionTitle": "Nombre obligatorio para pago único. Favor de llenar el campo",
        "DUPLICATE_ONE_TIME": "No se puede crear el mismo pago único para el mismo apartamento. elige un nombre diferente para él",
        "NO_ACTIVE_BUILDINGS": "No ha sido posible encontrar ningún edificio activo",
        "PHONE_PARAM_REQUIRED": "Phone number required",
        "PHONE_NOT_MATCH": "Phone number you've entered is unknown to the system",
        "PARTNER_MAPPING_MISMATCH": "No hay suficientes datos para realizar la exportación",
        "NOT_ENOUGH_TO_REFUND": "No se puede reembolsar. No hay suficiente dinero disponible. ({{refundAmount}} > {{availableAmount}})",
        "TEMP_ADMIN_ONLY": "Esta característica está disponible temporalmente solo para administradores",
        "APARTMENT_NOT_FOUND": "Apartamento no encontrado",
        "APARTMENT_ALREADY_INACTIVATED": "Apartamento {{apartmentNum}} en el edificio {{buildingId}} ya inactivo",
        "APARTMENT_HAS_PAYMENTS": "El apartamento {{apartmentNum}} en el edificio {{buildingId}} tiene pagos",
        "NO_PENDING_PAYMENTS_TO_DELETE": "No se pudo encontrar ningún pago pendiente para eliminar",
        "MAX_INSTALLMENTS_FOR_NEW_ONE_TIME": "max installments {{num}} is larger than max allowed",
        "NO_MAINTENANCE_CONFIGURED": "La característica de mantenimiento no está configurada",
        "CANT_PARSE_BANK_FILE": "No puedo analizar un archivo",
        "NO_PLAN_WERE_CREATED": "no se creó ningún plan, verifique si se seleccionaron artículos para cobrar",
        "UNEXPECTED_EXEL_FILE_FORMAT": "El archivo de Excel que ha enviado tiene un formato inesperado",
        "FILE_TOO_BIG": "archivo demasiado grande",
        "BUILDING_IS_DISABLED": "el edificio no existe o está inhabilitado temporalmente",

    }
};
